import apiSlice from "./ApiSlice";

const ExpenseCategoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllDrawerData: builder.query({
      providesTags: ["drawer"],
      query: () => {
        return {
          url: "/drawer",
          method: "GET",
        };
      },
    }),
    DrawerInOut: builder.mutation({
      invalidatesTags: ["drawer"],
      query: (body) => ({
        url: `/drawer/transaction`,
        method: "POST",
        body,
      }),
    }),
    DrawerExchange: builder.mutation({
      invalidatesTags: ["drawer"],
      query: (body) => ({
        url: `/drawer/exchange`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetAllDrawerDataQuery, useDrawerInOutMutation,useDrawerExchangeMutation } =
  ExpenseCategoriesApi;
